export const config = {
    "Fiat 500": {
        "displayname" : "Fiat 500",
        "carsize": "Small Car",
        "url": "https://assets.fcaab.com.au/assets-public/forms/fiat/500.jpg",
        "alt": "", cta: {
            "features": "https://www.fiat.com.au/fiat500.html",
            "offers": "https://www.fiat.com.au/offers/offers-fiat500.html",
            "testdrive": "https://www.fiat.com.au/request-a-test-drive.html?vehicle=fiat-500&year=2017",
            "brochure": "https://www.fiat.com.au/request-a-brochure.html?vehicle=fiat-500&year=2017",
            "quote" : "https://www.fiat.com.au/request-a-quote.html?vehicle=fiat-500&year=2017",
            "specs" : "https://www.fiat.com.au/content/dam/cross-regional/apac/fiat/en_au/pdf/FIAT_500_S7_BG-v5.pdf",
        },
        "year" : "2017"
        ,
        images: [
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/mobile/portrait/500.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/mobile/portrait/500.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/mobile/landscape/500.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/mobile/landscape/500.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/tablet/landscape/500.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/tablet/landscape/500.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/tablet/portrait/500.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/tablet/portrait/500.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/desktop/500.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/desktop/500.jpg 2x"

        ]

    },
    "Fiat 500C": {
        "displayname" : "Fiat 500C",
        "carsize": "Small Car",
        "url": "https://assets.fcaab.com.au/assets-public/forms/fiat/500C.jpg",
        "alt": "", cta: {
            "features": "https://www.fiat.com.au/fiat500.html",
            "offers": "https://www.fiat.com.au/offers.html",
            "testdrive": "https://www.fiat.com.au/request-a-test-drive.html?vehicle=fiat-500c&year=2017",
            "brochure": "https://www.fiat.com.au/request-a-brochure.html?vehicle=fiat-500c&year=2017",
            "quote" : "https://www.fiat.com.au/request-a-quote.html?vehicle=fiat-500c&year=2017",
            "specs" : "https://www.fiat.com.au/content/dam/cross-regional/apac/fiat/en_au/pdf/FIAT_500_S7_BG-v5.pdf",
        },
        "year" : "2017"
        ,
        images: [
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/mobile/portrait/500C.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/mobile/portrait/500C.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/mobile/landscape/500C.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/mobile/landscape/500C.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/tablet/landscape/500C.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/tablet/landscape/500C.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/tablet/portrait/500C.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/tablet/portrait/500C.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/desktop/500C.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/desktop/500C.jpg 2x"

        ]

    },
    "Abarth 595": {
        "displayname" : "Abarth 595",
        "carsize": "Small Car",
        "url": "https://assets.fcaab.com.au/assets-public/forms/fiat/595.jpg",
        "alt": "", cta: {
            "features": "https://www.fiat.com.au/595.html",
            "offers": "https://www.fiat.com.au/offers/offers-abarth595.html",
            "testdrive": "https://www.fiat.com.au/request-a-test-drive.html?vehicle=abarth-595&year=2017",
            "brochure": "https://www.fiat.com.au/request-a-brochure.html?vehicle=abarth-595&year=2017",
            "quote" : "https://www.fiat.com.au/request-a-quote.html?vehicle=abarth-595&year=2017",
            "specs" : "https://www.fiat.com.au/content/dam/cross-regional/apac/fiat/en_au/request-a-brochure/pdfs/Abarth_595_Brochure.pdf",

        },
        "year" : "2017"
        ,
        images: [
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/mobile/portrait/595.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/mobile/portrait/595.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/mobile/landscape/595.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/mobile/landscape/595.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/tablet/landscape/595.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/tablet/landscape/595.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/tablet/portrait/595.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/tablet/portrait/595.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/desktop/595.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/desktop/595.jpg 2x"

        ]

    },
    "Abarth 695": {
        "displayname" : "Abarth 695",
        "carsize": "Small Car",
        "url": "https://assets.fcaab.com.au/assets-public/forms/fiat/695.jpg",
        "alt": "", cta: {
            "features": "https://www.fiat.com.au/abarth/695.html",
            "offers": "https://www.fiat.com.au/offers/offers-abarth695.html",
            "testdrive": "https://www.fiat.com.au/request-a-test-drive.html?vehicle=abarth-695",
            "brochure": "https://www.fiat.com.au/request-a-brochure.html?vehicle=abarth-695&",
            "quote" : "https://www.fiat.com.au/request-a-quote.html?vehicle=abarth-695",
            "specs" : "https://www.fiat.com.au/content/dam/cross-regional/apac/fiat/en_au/pdf/MY22-Abarth-695.pdf",

        },
        "year" : "2022"
        ,
        images: [
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/mobile/portrait/695.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/mobile/portrait/695.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/mobile/landscape/695.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/mobile/landscape/695.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/tablet/landscape/695.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/tablet/landscape/695.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/tablet/portrait/695.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/tablet/portrait/695.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/desktop/695.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/desktop/695.jpg 2x"

        ]

    },
    "Abarth 124 Spider": {
        "displayname" : "Abarth 124 Spider",
        "carsize": "Sports",
        "url": "https://assets.fcaab.com.au/assets-public/forms/fiat/124.jpg",
        "alt": "", cta: {
            "features": "https://www.fiat.com.au/124spider.html",
            "offers": "https://www.fiat.com.au/offers/offers-abarth124spider.html",
            "testdrive": "https://www.fiat.com.au/request-a-test-drive.html?vehicle=abarth-124-spider&year=2017",
            "brochure": "https://www.fiat.com.au/request-a-brochure.html?vehicle=abarth-124-spider&year=2017",
            "quote" : "https://www.fiat.com.au/request-a-quote.html?vehicle=abarth-124-spider&year=2017",
            "specs" : "https://www.fiat.com.au/content/dam/cross-regional/apac/fiat/en_au/request-a-brochure/pdfs/124-Spider-Web-v5.pdf",

        },
        "year" : "2017"
        ,
        images: [
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/mobile/portrait/124.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/mobile/portrait/124.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/mobile/landscape/124.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/mobile/landscape/124.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/tablet/landscape/124.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/tablet/landscape/124.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/tablet/portrait/124.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/tablet/portrait/124.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/desktop/124.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/desktop/124.jpg 2x"

        ]

    },
    "Fiat 500E": {
        "displayname" : "Fiat 500E",
        "carsize": "Small Car",
        "url": "https://assets.fcaab.com.au/assets-public/forms/fiat/fiat500e.jpg",
        "alt": "", cta: {
            "features": "https://www.fiat.com.au/500e.html",
            "offers": "https://www.fiat.com.au/500e.html",
            "testdrive": "https://www.fiat.com.au/request-a-test-drive.html?vehicle=Fiat%20500E",
            "brochure": "https://www.fiat.com.au/request-a-brochure.html?vehicle=Fiat%20500E",
            "quote" : "https://www.fiat.com.au/request-a-quote.htmlvehicle=Fiat%20500E",
            "specs" : "",
        },
        "year" : "2023"
        ,
        images: [
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/mobile/portrait/fiat500e.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/mobile/portrait/fiat500e.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/mobile/landscape/fiat500e.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/mobile/landscape/fiat500e.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/tablet/landscape/fiat500e.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/tablet/landscape/fiat500e.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/tablet/portrait/fiat500e.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/tablet/portrait/fiat500e.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/desktop/fiat500e.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/desktop/fiat500e.jpg 2x"

        ]

    },
    "Abarth 500E": {
        "displayname" : "Abarth 500E",
        "carsize": "Small Car",
        "url": "https://assets.fcaab.com.au/assets-public/forms/fiat/ab500e.jpg",
        "alt": "", cta: {
            "features": "https://www.fiat.com.au/500e.html",
            "offers": "https://www.fiat.com.au/500e.html",
            "testdrive": "https://www.fiat.com.au/request-a-test-drive.html?vehicle=Abarth%20500E",
            "brochure": "https://www.fiat.com.au/request-a-brochure.html?vehicle=Abarth%20500E",
            "quote" : "https://www.fiat.com.au/request-a-quote.htmlvehicle=Abarth%20500E",
            "specs" : "",
        },
        "year" : "2023"
        ,
        images: [
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/mobile/portrait/ab500e.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/mobile/portrait/ab500e.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/mobile/landscape/ab500e.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/mobile/landscape/ab500e.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/tablet/landscape/ab500e.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/tablet/landscape/ab500e.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/tablet/portrait/ab500e.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/tablet/portrait/ab500e.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/desktop/ab500e.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/desktop/ab500e.jpg 2x"

        ]

    },
    models : [
        'Fiat 500',
        'Fiat 500E',
        'Abarth 500E',
        'Abarth 695',
    ],
    privacypolicy : "https://www.fiat.com.au/privacy.html",
    ra : "https://www.fiat.com.au/roadside-assistance.html",
    "compPrivacypolicy" : "https://www.fiat.com.au/privacy.html",
    brochureSentByEmail: true,
    virtualtestdrivedealers: [

        {name: "Barbagallo Fiat" , email : "barbagallofiatalfaromeo@gmail.com" , suburb : "Perth" , postcode : "6017"},
        {name: "Brighton Fiat" , email : "brightonfiatalfaromeo@gmail.com" , suburb : "Brighton" , postcode : "3204"},
        {name: "FR Ireland Fiat" , email : "frirelandfiatalfaromeo@gmail.com" , suburb : "Cairns" , postcode : "4870"},
        {name: "Gulson Fiat" , email : "gulsonfiatalfaromeo@gmail.com" , suburb : "Canberra" , postcode : "2609"},
        {name: "McCarroll's Fiat - Artarmon" , email : "mccarrollsfiatalfaromeo@gmail.com" , suburb : "Artarmon" , postcode : "2064"},
        {name: "Mt Gravatt Fiat" , email : "mtgravattjeepfiat@gmail.com" , suburb : "Mt Gravatt" , postcode : "4122"},
        {name: "Nunawading Fiat" , email : "nunawadingfiatalfaromeo@gmail.com" , suburb : "Nunawading" , postcode : "3131"},
        {name: "Parramatta Fiat" , email : "parramattafiatalfaromeo@gmail.com" , suburb : "Parramatta" , postcode : "2142"},
        {name: "Peter Warren Fiat" , email : "peterwarrenjeepfiat@gmail.com" , suburb : "Liverpool" , postcode : "2170"},
        {name: "Solitaire Fiat" , email : "solitairefiatalfaromeo@gmail.com" , suburb : "Adelaide" , postcode : "5063"},
        {name: "Sunshine Coast Fiat" , email : "sunshinecoastfiatalfaromeo@gmail.com" , suburb : "Sunshine Coast" , postcode : "4566"},
        {name: "Southern Classic Fiat" , email : "southernclassicfiatalfaromeo@gmail.com" , suburb : "Wollongong" , postcode : "2500"},
        {name: "Zagame Fiat" , email : "zagamefiatalfaromeo@gmail.com" , suburb : "Richmond" , postcode : "3121"},


    ],


};
